export default __webpack_public_path__ + "static/media/recommendation.a2d6f09e.svg";